export const environment = {
  production: true,
  urlPrefix: '',
  version: 'BUILD_VERSION',
  defaultLang: 'uk',
  secondaryLang: 'ru',
  name: 'Girko.net',
  phoneMask: '(000) 000-00-00',
  phonePrefix: '',
  currency: 'грн.',
};
